import { QUOTE_TYPES } from './data';

/** Matches inventory select rules: Exchange → exchangePrice; Both → both; else outright price. */
export function hasValidInventoryPriceForType(line) {
    const type = line?.type ?? QUOTE_TYPES.OUTRIGHT;
    
    const exchangePrice = line?.exchangePrice;

    const hasOutright = Boolean(line?.outrightPrice && line.outrightPrice != 0);
    const hasExchange = Boolean(exchangePrice && exchangePrice != 0);

    if (type === QUOTE_TYPES.EXCHANGE) return hasOutright && hasExchange;
    return hasOutright;
}
